import {BaseService} from "./BaseService";
import {CheckoutHistory} from "../entities/CheckoutHistory";
import { StateService } from "@uirouter/angularjs";

export class CheckoutHistoryService extends BaseService<CheckoutHistory>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, CheckoutHistory);
    }
    protected getBaseUrl():string{
        return "checkouthistory";
    }
    protected getBasesUrl():string{
        return "checkouthistories";
    }
    getByAsset(assetId:number){
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"asset/"+assetId, config);
    }
    getReport(assetname: string, username: string, startDate: string, endDate: string){
        var config:any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        var timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.useGetHandler("Report", "CheckoutHistory?timeZoneId=" + timeZoneId + "&name=" + "&assetName=" + assetname + "&username=" + username + "&startDate=" + startDate + "&endDate=" + endDate, config);
    }
    getReportCount(assetname:string,username:string, startDate:string, endDate:string){
        var config: any = {};
        var timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.useGetHandler(this.getBasesUrl(), "ReportCount?timeZoneId=" + timeZoneId+"&name=" + assetname + "&username=" + username + "&startDate=" + startDate + "&endDate=" + endDate, config);
    }
    getReportItems(assetname:string,username:string):ng.IPromise<CheckoutHistory[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"Report?name="+assetname+"&username="+username, config);
    }
}
